export const formatFilter = filter => {
  const jsonFilter = `{${filter.toString()}}`;
  return encodeURI(jsonFilter);
};
